import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
const SPOTS_LEFT = 7;
const FILLED = 93;
export function ScarcityBar() {
  return <div className="mx-auto mt-6 w-full max-w-xl rounded-2xl border-2 border-red-200 bg-red-50 p-4" data-id="element-304" data-mp="2yy5nyvthfm87">
      <div className="flex items-center justify-between gap-3" data-id="element-305" data-mp="2q40zuk5qgowd">
        <p className="flex items-center gap-1.5 text-sm font-extrabold text-red-700" data-id="element-306" data-mp="2q2g10icdyjsp">
          <FlameIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-307" data-mp="2b5yvw8usi1el" />
          Only {SPOTS_LEFT} spots left at $27
        </p>
        <span className="text-sm font-extrabold text-red-700 tabular-nums" data-id="element-308" data-mp="2g3qlgw7ypbfm">{FILLED}% claimed</span>
      </div>
      <div className="mt-2.5 h-4 w-full overflow-hidden rounded-full bg-red-100" role="progressbar" aria-valuenow={FILLED} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-309" data-mp="228erir1mrozr">
        <motion.div className="h-full rounded-full bg-red-600" initial={{
        width: '60%'
      }} whileInView={{
        width: `${FILLED}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-310" data-mp="5ch0gtxo7d04" />
      </div>
      <p className="mt-2 text-xs font-medium text-red-800/80" data-id="element-311" data-mp="3dcxzkixw0n3j">
        When the remaining promotional spots are claimed, the price returns to the regular value.
      </p>
    </div>;
}